export default __webpack_public_path__ + "static/media/default_minus.506d2c61.svg";